import React, { useEffect } from "react";
import "./privacy.scss";
function Privacy() {
  useEffect(() => {
    document.title = "educare - Privacy";

    return () => {
      document.title = "educare ";
    };
  });
  return (
    <>
      <div className="terms-bg">
        <center>
          <h1>Privacy Policy</h1>
        </center>
      </div>
      <div className="terms-inner offset-md-2 col-md-8">
        <h1>Introduction</h1>
        <p>
          Thank you for choosing Educare Technology Solutions Limited
          (“Educare,” “we,” “our,” or “us”). We are committed to safeguarding
          your privacy and protecting your personal information. This Privacy
          Policy explains how we collect, use, and safeguard your data when you
          use our Software-as-a-Service (SaaS) products, including{" "}
          <strong>“Educare for School”</strong> and{" "}
          <strong>“Educare for Business.”</strong>
        </p>
        <p>This Privacy Policy outlines:</p>
        <ul>
          <li>What personal data we collect;</li>
          <li>Why we collect it;</li>
          <li>How we use and store it;</li>
          <li>The circumstances under which we may share it; and</li>
          <li>Your rights regarding your personal data.</li>
        </ul>
        <p>
          By using our website or services, you acknowledge that you have read
          and understood this Privacy Policy and consent to our collection, use,
          disclosure, and retention of your data as described herein.
        </p>
        <h1>1. Definitions</h1>
        <ul>
          <li>
            <strong>Account –</strong> A user account created to access
            Educare’s services.
          </li>
          <li>
            <strong>Personal Data / Personal Information –</strong> Any
            information that identifies or relates to an individual or
            organization (e.g., name, email, phone, school, business, student
            records, login credentials).
          </li>
          <li>
            <strong>Services –</strong> All features, modules, portals, and
            applications offered by Educare, including student information
            management, attendance, finance, academics, HR, communication,
            analytics modules, and business management modules.
          </li>
          <li>
            <strong>User –</strong> Any individual or institution using
            Educare’s Services.
          </li>
          <li>
            <strong>We / Us / Our –</strong> Educare Technology Solutions
            Limited.
          </li>
        </ul>

        <h4>2. Information We Collect</h4>

        <ol>
          <p>We may collect:</p>
          <li>
            <strong> Account and Profile Data –</strong> Name, email, phone
            number, school or business name, role (teacher, admin, parent,
            employee, manager), and account credentials.
          </li>
          <li>
            <strong>Operational Data –</strong> Academic or business records,
            attendance, fee/payment information, exam results,
            timetable/scheduling, HR records, library usage, or other data
            entered by schools or businesses.
          </li>
          <li>
            <strong>Usage and Technical Data –</strong> IP address, device type,
            browser, timestamps, session activity, analytics data, cookies.
          </li>
          <li>
            <strong>Payment Data –</strong> Where applicable, billing
            information and payment identifiers. Payment card data is processed
            securely through third-party providers.
          </li>
        </ol>

        <h4>3. Purpose of Collection</h4>
        <p>We use your data to:</p>
        <ul>
          <li>Operate and maintain our Services.</li>
          <li>Manage user accounts and authentication.</li>
          <li>
            Facilitate school and business management (attendance, HR, finance,
            academics, communication).
          </li>
          <li>Respond to support requests and provide customer service.</li>
          <li>Analyze and improve the Services.</li>
          <li>
            Comply with legal obligations and protect against fraud or misuse.
          </li>
          <li>Manage payments and subscriptions, where applicable.</li>
        </ul>

        <h4>4. Data Sharing and Disclosure</h4>
        <p>
          We <strong>do not sell your data</strong>. We may share data with:
        </p>
        <ul>
          <li>
            <strong>Service Providers –</strong> Hosting, cloud infrastructure,
            analytics, payment processing, or email services.
          </li>
          <li>
            <strong>Legal Authorities –</strong> If required by law or
            regulation.
          </li>
          <li>
            <strong>Business Transfers –</strong> In case of mergers,
            acquisitions, or sale of assets.
          </li>
        </ul>
        <p>
          All third parties are required to maintain confidentiality and use
          data only as necessary to provide services to Educare.
        </p>

        <h4>5. Data Storage and Security n</h4>
        <p>
          We store data securely with reasonable technical and organizational
          measures, including encryption and access control. Data is retained
          only as long as necessary to fulfill purposes outlined or comply with
          legal requirements.
        </p>

        <h4>6. User Rights</h4>
        <p>Users have the right to:</p>

        <ul>
          <li>Access personal data we hold about them.</li>
          <li>Correct or update inaccurate or incomplete data.</li>
          <li>Object to processing or withdraw consent (where applicable).</li>
          <li>
            Request deletion of data, subject to legal and operational
            constraints.
          </li>
          <li>Lodge complaints regarding data handling.</li>
        </ul>
        <p>
          To exercise your rights, contact us at:
          <br />
          <strong>Email:</strong> support@educare.ng
        </p>
        <p>
          <strong>Address:</strong> 16B, Alhaji Hussein Sunmonu Street, Lekki
          Phase 1, Lagos State, Nigeria
        </p>

        <h4>7. Cookies and Tracking</h4>
        <p>We may use cookies and similar technologies to:</p>

        <ul>
          <li>Remember user preferences</li>
          <li>Analyze usage</li>
          <li>Improve functionality</li>
        </ul>
        <p>
          You can manage cookies via your browser settings, but disabling them
          may affect some functionality.
        </p>

        <h4>8. Minors</h4>
        <p>
          Our Services may be used by students under 18 only with parental or
          guardian consent. We do not knowingly collect personal data from
          minors without verifiable consent.
        </p>

        <h4>9. Changes to Privacy Policy</h4>
        <p>
          We may update this Privacy Policy periodically. The “Last Updated”
          date will indicate the most recent version. Continued use of the
          Services constitutes acceptance of any updates.
        </p>

        <h4>10. Contact Information</h4>
        <p>
          Educare Technology Solutions Limited
          <br /> 16B, Alhaji Hussein Sunmonu Street, Lekki Phase 1, Lagos State,
          Nigeria
          <br />
          <strong>Email:</strong> support@educare.ng
        </p>
      </div>
    </>
  );
}

export default Privacy;
